import { createSelector } from 'reselect';
import { initialState } from '../reducers/contact.reducer';
import { CONTACTS } from '../constants/contact.constants';

const selectState = state => state[CONTACTS] || initialState;

export const selectContacts = () => createSelector(selectState, state => state.get('data').filter(g => !g.get('emergency')).toList().sortBy(a => (a.get('name') || '').toLowerCase()));
export const selectContactsFetched = () => createSelector(selectState, state => state.get('fetched'));